// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-training-dialog-content {
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
  width: 100%;
}

.start-training-dialog-text {
  font-size: var(--font-size-l);
}

.start-training-fields {
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
  width: 100%;
}

.start-training-field-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: var(--dialog-element-gap);
}

.start-training-field-label {
  font-size: var(--font-size-l);
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/training-dialog/start-training-dialog/StartTrainingDialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd","sourcesContent":[".start-training-dialog-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n  width: 100%;\n}\n\n.start-training-dialog-text {\n  font-size: var(--font-size-l);\n}\n\n.start-training-fields {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n  width: 100%;\n}\n\n.start-training-field-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--dialog-element-gap);\n}\n\n.start-training-field-label {\n  font-size: var(--font-size-l);\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
